import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";
import CarListPage from "./pages/CarListPage";
import ContactPage from "./pages/ContactPage";
import ReservationPage from "./pages/ReservationPage";
import CarDetailPage from "./pages/CarDetailPage";
import { CarProvider } from "./context/CarContext";
import "./styles/global.css";

const App = () => {
  // Fonction pour ajuster la hauteur de la fenêtre sur mobile
  useEffect(() => {
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Exécuter au chargement et à chaque redimensionnement
    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);
    
    return () => window.removeEventListener('resize', setViewportHeight);
  }, []);

  return (
    <CarProvider>
      <Router>
        <div className="app-container">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/voitures" element={<CarListPage />} />
              <Route path="/contact" element={<ContactPage />} /> {/* Route pour la page de contact */}
              <Route path="/reservation" element={<ReservationPage />} />
              <Route path="/voitures/:id" element={<CarDetailPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </CarProvider>
  );
};

export default App;
